import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appFTRITRNFilter]',
})
export class FtrItnFilterDirective {
  @Output() onValidate = new EventEmitter<boolean>(); // Emits a string
  // The ITN begins with the letter "X", followed by the date of acceptance (year, month, day) and six random digits (e.g., X20230101777777)
  private regex: RegExp = new RegExp(
    /^X(19|20)\d{2}(0[1-9]|1[1,2])(0[1-9]|[12][0-9]|3[01])\d\d\d\d\d\d$/g
  );

  constructor(private el: ElementRef) {}

  //capture keys and ctrl-v
  @HostListener('keyup', ['$event']) onKeyUp(e: KeyboardEvent) {
    let current: string = this.el.nativeElement.value;

    if (current && String(current).match(this.regex) == null) {
      this.el.nativeElement.style = 'border-color:red';
      this.onValidate.emit(false);
    } else {
      this.onValidate.emit(true);
      this.el.nativeElement.style = 'border-color:grey';
    }
  }

  //capture right-click paste event
  @HostListener('paste', ['$event']) onPaste(e: ClipboardEvent) {
    return;
  }
}
